module.exports = __webpack_public_path__ + "static/media/muscle.1b153f20.png";